module.exports = __webpack_public_path__ + "img/06.f56f0631.jpg";